import Repository from './Repository'
import Exam from '../models/Exam'

export default {

    createNew(course) {
        return new Exam(
            course,
            1,
            course.pickExamQuestions(),
        );
    },

    load(course) {
        let data = Repository.loadExam(course.id);

        if (data) {
            return new Exam(
                course,
                data.currentQuestion,
                data.questions,
                data.answers,
                data.finished
            );
        }
        else {
            return this.createNew(course);
        }
    }
}